import {ContestPickType} from "../constants/PickXEnums";
import {deepClone} from "../utils/AppUtils";

export default class ContestPick {
    ContestId;
    Pick;
    PickCustomValue;
    Result=0;
    LineValue;
    OverOdds;
    UnderOdds;

    get IsOver() { return this.Pick === ContestPickType.Over }
    get IsUnder(){ return this.Pick === ContestPickType.Under }
    get IsCustom(){ return this.Pick === ContestPickType.Custom }

    constructor(data) {
        Object.assign(this, data);
    }

    toDto(){
        return deepClone(this);
    }
}